var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import getId from "@irati/utils/id";
import { H2 } from "@irati/ui/src/Typography";
import DealModes from "../../enums/DealModes";
import { H4Title, H5Title } from "./styled";
var UnavailableDealHeaderDetails = function (_a) {
    var deal = _a.deal, _b = _a.mode, mode = _b === void 0 ? DealModes.Default : _b, props = __rest(_a, ["deal", "mode"]);
    var isFullPage = mode === DealModes.FullPage;
    var isCompact = mode === DealModes.Compact;
    return (React.createElement("div", null,
        isFullPage && (React.createElement(H2, { id: getId("title", props), paddingBottom: 2, overflowWrap: "break-word" }, deal.header)),
        !isFullPage && !isCompact && React.createElement(H4Title, { id: getId("title", props) }, deal.header),
        !isFullPage && isCompact && React.createElement(H5Title, { id: getId("title", props) }, deal.header)));
};
export default UnavailableDealHeaderDetails;
